import {
  getBooleanField,
  getDateField,
  getFloatField,
  getIntegerField,
  getTextField,
} from '@lender/utils';
import { object } from 'yup';

import { GROUP_DIVIDER, RESULT_FIELD_ID_PARTS_DIVIDER } from 'constants/documentExtractionFields';
import { DOC_FIELD_TYPES, dropDownDocumentFieldTypes } from 'constants/documentFieldTypes';
import { checkIsContainerType } from 'utils/documentFieldTypes';

const fieldTypeHandlers = {
  [DOC_FIELD_TYPES.BOOL]: getBooleanField,
  [DOC_FIELD_TYPES.DOUBLE]: getFloatField,
  [DOC_FIELD_TYPES.INTEGER]: getIntegerField,
  [DOC_FIELD_TYPES.COMPLEX]: getTextField,
  [DOC_FIELD_TYPES.TEXT]: getTextField,
  [DOC_FIELD_TYPES.SINGLE_SELECTION_DROP_DOWN]: getTextField,
  [DOC_FIELD_TYPES.MULTIPLE_SELECTION_DROP_DOWN]: getTextField,
  [DOC_FIELD_TYPES.DATE]: getDateField,
};

const generateDocSchemaField = (type, isRequired) => {
  const handler = fieldTypeHandlers[type];

  return handler ? handler({ isRequired }) : undefined;
};

// A row added to a table clones its fields as `<field id>___<table id>-nestedGroups-<row id>`; its options
// keep the field's own id as their parent (LEN-194: CIS's Funding Worksheet disbursement rows).
const getSourceFieldId = id => id.split(RESULT_FIELD_ID_PARTS_DIVIDER)[0].split(GROUP_DIVIDER)[0];

export const generateDocValidationSchema = (fieldsArr = []) => {
  const shape = fieldsArr.reduce((acc, { id, type, isRequired, isFilled }, index, fields) => {
    const isContainerType = checkIsContainerType(type);
    const isDropdownType = dropDownDocumentFieldTypes.includes(type);

    const isExcluded = isDropdownType
      ? !fields.some(({ parentId }) => parentId === getSourceFieldId(id))
      : false;

    if (!isContainerType && !isExcluded) {
      const isFieldRequired = !isFilled && isRequired;
      acc[id] = generateDocSchemaField(type, isFieldRequired);
    }

    return acc;
  }, {});

  return object().shape(shape);
};
